import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

const SUPPORTED = ["it", "en", "de"];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" && window.localStorage.getItem("sorriso_lang");
    if (stored && SUPPORTED.includes(stored)) return stored;
    const nav = typeof navigator !== "undefined" ? (navigator.language || "de").slice(0, 2) : "de";
    return SUPPORTED.includes(nav) ? nav : "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("sorriso_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang] || translations.it;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, supported: SUPPORTED }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
